import { render, staticRenderFns } from "./CCrimePrevention.vue?vue&type=template&id=3038cc72"
import script from "./CCrimePrevention.vue?vue&type=script&lang=js"
export * from "./CCrimePrevention.vue?vue&type=script&lang=js"
import style0 from "./CCrimePrevention.vue?vue&type=style&index=0&id=3038cc72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports